// dependencies

// TODO: Add translation

export default function (props) {
  return (props.children)
}
